import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";

/**
 * - ?sentry_test=1: envia evento E2E (filtrado pelo beforeSend, não aparece no Sentry).
 * - ?sentry_debug=1: envia evento NÃO filtrado para validar pipeline em produção.
 */
export function SentryTestTrigger() {
  const location = useLocation();
  const fired = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const debug = params.get("sentry_debug") === "1";
    const test = params.get("sentry_test") === "1";
    if ((!debug && !test) || fired.current) return;
    fired.current = true;

    const dsn = import.meta.env.VITE_SENTRY_DSN;
    if (!dsn) {
      if (debug) console.warn("[Sentry] DSN ausente no build. Configure VITE_SENTRY_DSN na Vercel e faça redeploy.");
      return;
    }

    if (debug) {
      // Mensagem que NÃO bate em SENTRY_IGNORE_PATTERNS — deve aparecer no Sentry
      Sentry.captureException(new Error("DEBUG-SENTRY-PIPELINE: teste manual (sentry_debug=1)"), {
        tags: { source: "sentry-debug-manual", env: import.meta.env.MODE },
      });
      if (import.meta.env.DEV) console.log("[Sentry] Evento de debug enviado. Verifique Sentry → Issues nas próximas horas.");
    } else if (test) {
      Sentry.captureException(new Error("E2E Sentry pipeline test — smoke completo"), {
        tags: { source: "e2e-sentry-smoke" },
      });
    }
  }, [location.search]);

  return null;
}
